export default __webpack_public_path__ + "static/media/pelvic-hypertonic.af5878ad.png";